module.exports = __webpack_public_path__ + "static/media/soTellUsSquareLogo.21a4e9dc.png";